export const isUndefined = (x: unknown): x is undefined =>
  typeof x === 'undefined'

export const isNumber = (x: unknown): x is number =>
  typeof x === 'number' && !Number.isNaN(x)

export const isString = (x: unknown): x is string => typeof x === 'string'

export const isArray = Array.isArray

export const isFunction = (x: unknown): x is (...args: any[]) => any =>
  typeof x === 'function'

export const isObject = (x: unknown): x is Record<string, unknown> =>
  typeof x === 'object' &&
  x !== null &&
  !(x instanceof FormData) &&
  !isArray(x) &&
  !isFunction(x)

// eslint-disable-next-line no-restricted-globals
export const coercedIsNaN = isNaN
